// Only assistant presentation is normalized. User messages and meaningful negative values stay intact.
export function chatProse(text) {
  return text
    .replace(/\bHelios\s*IQ\b/gi, "Helios Brain")
    .replace(/^[ \t]*(?:(?:[-+*\u2022\u25cf\u25aa]|\d{1,2}[.)])(?:[ \t]+|$)|#{1,6}[ \t]+|>[ \t]+)/gm, "")
    .replace(/[ \t]*[\u2013\u2014][ \t]*/g, (match, offset, source) => /\d$/.test(source.slice(0, offset).trimEnd()) && /^\d/.test(source.slice(offset + match.length).trimStart()) ? match : ", ")
    .replace(/(\*\*|__)([^\n]+?)\1/g, "$2")
    .replace(/\n{3,}/g, "\n\n").trim();
}